import "moment-timezone";
import React, { useEffect, useState } from "react";
import { Button, Modal } from 'react-bootstrap';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import TrialCoachingSessionsService from '../utils/TrialCoachingSessionsService';

const AssignTCSModal = ({ deal, showModal, onConfirmModal, onCloseModal }) => {
  const [assignees, setAssignees] = useState()
  const [showAssigneeDetail, setShowAssigneeDetail] = useState([])

  useEffect(() => {
    if (!deal || !showModal) return;
    setShowAssigneeDetail([])
    setAssignees()
    getAssignees()
    if (!deal.last_name) deal.last_name = deal.lm_contact ? deal.lm_contact.last_name : null
    if (!deal.first_name) deal.first_name = deal.lm_contact ? deal.lm_contact.first_name : null
    if (!deal.email) deal.email = deal.lm_contact ? deal.lm_contact.email : null
    if (!deal.region) deal.region = deal.lm_contact ? deal.lm_contact.region : null
  }, [deal, showModal]);


  const getAssignees = () => {
    if (!deal) return
    TrialCoachingSessionsService.getAssignees(deal.id).then(data => {
      const deals = data.deals.sort((a, b) => new Date(a.tcs_at) - new Date(b.tcs_at))
      const assignees = data.assignees
        .map((assignee) => {
          assignee.assignedToDeals = deals.filter(
            (d) => d.tcs_assigned_to === assignee.email
          );
          assignee.clashingBookings = deals.filter(
            (d) =>
              d.tcs_at === deal.tcs_at &&
              d.tcs_assigned_to === assignee.email &&
              d.id !== deal.id
          );
          if (!assignee.options.tcs_priority)
            assignee.options.tcs_priority = 10;
          return assignee;
        })
        .sort((a, b) =>
          a.options.tcs_priority > b.options.tcs_priority ? 1 : -1
        );

      const assigneeGroups = {
        workingNotBooked: assignees.filter(
          (a) => a.working && a.clashingBookings.length === 0
        ),
        notWorkingNotBooked: assignees.filter(
          (a) => !a.working && a.clashingBookings.length === 0
        ),
        workingBooked: assignees.filter(
          (a) => a.working && a.clashingBookings.length !== 0
        ),
        notWorkingBooked: assignees.filter(
          (a) => !a.working && a.clashingBookings.length !== 0
        ),
      };

      setAssignees(assigneeGroups);
    });
  }

  if (!deal) return null

  const assignTo = (dealId, email) => {
    TrialCoachingSessionsService.takeAction('assign', dealId, { email: email }).then((response) => {
      Alert.success(`Assigned to ${response.tcs_assigned_to || 'nobody'}`)
      onConfirmModal(response)
    })
  }

  const showDetails = (as) => {
    setShowAssigneeDetail(showAssigneeDetail.includes(as.email) ? showAssigneeDetail.filter((ad) => ad !== as.email) : showAssigneeDetail.concat(as.email))
  }

  const AssigneeTable = ({ title, assigneesToInclude }) => (
    <>
      <h5 style={{ fontWeight: 700 }}>{title}</h5>
      {assigneesToInclude.length === 0 ? <p style={{color: '#888', paddingLeft:20}}>no matches</p>
      : <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
        <table className="table table-condensed table-hover" style={{ minWidth: '600px' }}>
        <tbody>
          {assigneesToInclude.map((as) => {
            return (
              <>
                <tr
                  style={{ cursor: "pointer", borderBottom: "1px solid #ccc" }}
                >
                  <td onClick={() => showDetails(as)}>
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ paddingLeft: 5, paddingRight: 5 }}>
                            {as.options.tcs_priority}
                          </td>
                          <td style={{ paddingLeft: 5, paddingRight: 5 }}>
                            {as.name} {as.region && `- ${as.region}`} &lt;{as.email}&gt;
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td onClick={() => showDetails(as)} style={{ width: 280 }}>
                    <div>
                      <div className="row">
                        <div className="col-md-6">
                          Assigned: {as.assignedToDeals.length}
                        </div>
                        <div className="col-md-6">
                          <span
                            className={
                              as.clashingBookings.length > 0
                                ? "text-danger"
                                : ""
                            }
                          >
                            Clashes: {as.clashingBookings.length}
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: 50 }}>
                    <Button
                      bsStyle="info"
                      bsSize="xs"
                      onClick={(e) => {
                        assignTo(deal.id, as.email);
                        e.preventDefault();
                      }}
                    >
                      Assign
                    </Button>
                  </td>
                </tr>
                {showAssigneeDetail.includes(as.email) && as.options.tcs_work_hours && <tr>
                    <td colSpan={3} style={{ color: '#666', fontSize: 13, fontWeight: 600, padding: "0 30px", paddingBottom: (as.clashingBookings.length === 0 && as.assignedToDeals.length === 0 && '10px')  }}>
                      {as.options.tcs_work_hours}
                    </td>
                  </tr>}

                {showAssigneeDetail.includes(as.email) &&
                  (as.clashingBookings.length > 0 ||
                    as.assignedToDeals.length > 0) && (
                    <tr>
                      <td colSpan={3}>
                        <div style={{ padding: "0 10px 10px 10px", overflowX: 'auto' }}>
                          <table style={{ width: "100%", fontSize: 14, minWidth: '500px' }}>
                            <tbody>
                              {as.clashingBookings.map((deal) => (
                                <tr className="text-danger">
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    <Link
                                      to={`/m1/deals/${deal.id}`}
                                      target="_new"
                                    >
                                      Deal #{deal.id}
                                    </Link>
                                  </td>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    Clash
                                  </td>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    {deal.contact_name}
                                  </td>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    Yr: {deal.student_year_level}
                                  </td>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    Parents:{" "}
                                    {deal.tcs_parents_attending_tcs || "?"}/
                                    {deal.tcs_parents_in_household || "?"}
                                  </td>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    {deal.tcs_at ? (
                                      <Moment format="h:mma MMM Do YYYY">
                                        {deal.tcs_at}
                                      </Moment>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                </tr>
                              ))}
                              {as.assignedToDeals.map((deal) => (
                                <tr>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    <Link
                                      to={`/m1/deals/${deal.id}`}
                                      target="_new"
                                    >
                                      Deal #{deal.id}
                                    </Link>
                                  </td>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    Assigned
                                  </td>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    {deal.contact_name}
                                  </td>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    Yr: {deal.student_year_level}
                                  </td>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    Parents:{" "}
                                    {deal.tcs_parents_attending_tcs || "?"}/
                                    {deal.tcs_parents_in_household || "?"}
                                  </td>
                                  <td style={{ padding: "0 0 5px 1px" }}>
                                    {deal.tcs_at ? (
                                      <Moment format="h:mma MMM Do YYYY">
                                        {deal.tcs_at}
                                      </Moment>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  )}
              </>
            );
          })}
        </tbody>
      </table>
      </div>}
    </>
  );

  return (
    <Modal show={showModal} onHide={onCloseModal} dialogClassName="modal-lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Assign TCS{" "}
          <i className="fas fa-caret-right" style={{ margin: "0 10px" }}></i>{" "}
          {deal.first_name} {deal.last_name} in {deal.region}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {assignees ? (
          <>
            <div
              style={{
                marginBottom: 15,
                paddingBottom: 5,
                borderBottom: "1px solid #ccc",
                fontSize: 18,
              }}
            >
              <div className="pull-right">
                <Button
                  bsStyle="info"
                  bsSize="xs"
                  onClick={(e) => {
                    assignTo(deal.id, null);
                    e.preventDefault();
                  }}
                >
                  Set to UNASSIGNED
                </Button>
              </div>
              <div>
                <Link to={`/m1/deals/${deal.id}`} target="_new">
                  Deal #{deal.id}
                </Link>{" "}
                for {deal.first_name} {deal.last_name} &lt;{deal.email}&gt;
              </div>
              <div>
                <Moment format="h:mma MMM Do YYYY">{deal.tcs_at}</Moment>{" "}
              </div>
              <div>
                Parents: {deal.tcs_parents_attending_tcs} attending /{" "}
                {deal.tcs_parents_in_household} in house
              </div>
            </div>
            {assignees && (
              <>
                <AssigneeTable
                  title="Working, Not Booked"
                  assigneesToInclude={assignees.workingNotBooked}
                />
                <AssigneeTable
                  title="Not Working, Not Booked"
                  assigneesToInclude={assignees.notWorkingNotBooked}
                />
                <AssigneeTable
                  title="Working, Booked"
                  assigneesToInclude={assignees.workingBooked}
                />
                <AssigneeTable
                  title="Not Working, Booked"
                  assigneesToInclude={assignees.notWorkingBooked}
                />
              </>
            )}

            {/* <h5 style={{fontWeight: 600}}>Other Users</h5>
          {assignees && <AssigneeTable assigneesToInclude={assignees.filter((as) => !as.roles.includes('tcs_coach'))} />} */}

            <ul style={{ marginTop: 20, fontSize: 14 }}>
              <li>Assigned figures are in the next 7 days</li>
              <li>
                Clashes only checks for other TCS's at the same time, not coach
                availability
              </li>
            </ul>
          </>
        ) : (
          <p>Loading</p>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default AssignTCSModal